import React from 'react';
import PropTypes from 'prop-types';
import { Table, Popover, Divider, Progress, Tooltip } from 'antd';
import { PhoneOutlined, MailOutlined } from '@ant-design/icons';
import './styles.css';

const { Column } = Table;

const CommentsByRestoTable = ({ data }) => {
    return (
        <Table className="commentsByRestoTableCont" dataSource={data} rowKey="id" size="middle" pagination={false}>
            <Column title="Fecha - hora" dataIndex="date" key="date" align="center" 
            render={(text, record) => {
                return (
                <span>
                    {`${record.date} - ${record.hour}`}
                </span>);
            }}/>
            <Column title="Usuario" dataIndex="name" key="name" align="center" 
            render={(text, record) => {
                    return (
                    <div>
                        {record.user.userName + " "}
                        <Popover content={
                            <div>
                                {
                                    record.user.userPhone && record.user.userPhone !== "" ?
                                        <p>Teléfono: {record.user.userPhone}</p>
                                        :
                                        <p>No hay teléfono registrado</p>
                                }
                            </div>
                        }>
                            <PhoneOutlined />
                        </Popover>
                        <Divider type="vertical" />
                        <Popover content={
                            <div>
                                {
                                    record.user.userEmail && record.user.userEmail !== "" ?
                                        <p>Correo electrónico: {record.user.userEmail}</p>
                                        :
                                        <p>No hay correo electrónico registrado</p>
                                }
                            </div>
                        }>
                            <MailOutlined />
                        </Popover>
                    </div>);
                }}/>
            <Column title="Comentario" dataIndex="comment" key="comment" align="center" />
            <Column title="Comida" dataIndex="ratingFood" key="ratingFood" align="center"
                render={ratingFood => {
                    const percent = Math.floor((ratingFood * 100) / 5);
                    return (
                    <span>
                        <Tooltip title={ratingFood + " de 5"}>
                            <Progress percent={percent} type="circle" width={50} strokeColor="#94509b" format={percent => `${ratingFood}`} />
                        </Tooltip>
                    </span>);
                }}
            />
            <Column title="Servicio" dataIndex="ratingService" key="ratingService" align="center"
                render={ratingService => {
                    const percent = Math.floor((ratingService * 100) / 5);
                    return (
                    <span>
                        <Tooltip title={ratingService + " de 5"}>
                            <Progress percent={percent} type="circle" width={50} strokeColor="#7078b8" format={percent => `${ratingService}`} />
                        </Tooltip>
                    </span>);
                }}
            />
            <Column title="Ambiente" dataIndex="ratingAmbient" key="ratingAmbient" align="center"
                render={ratingAmbient => {
                    const percent = Math.floor((ratingAmbient * 100) / 5);
                    return (
                    <span>
                        <Tooltip title={ratingAmbient + " de 5"}>
                            <Progress percent={percent} type="circle" width={50} strokeColor="#3383FF" format={percent => `${ratingAmbient}`} />
                        </Tooltip>
                    </span>);
                }}
            />
        </Table>
    );
};

CommentsByRestoTable.propTypes = {
    data: PropTypes.array,
};

export default CommentsByRestoTable;